export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  uc_host: 'https://user.moran9.com',
  site_host: 'https://geo.moran9.com',
  special_url: '/',
  site_title: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  welcome_title: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  site_short_title: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  site_subtitle: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  company_name: 'GEO软文推广 - 轻创圈geo软文自助发布平台，geo推广营销',
  copyright: '© 2026 轻创圈',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260819/179c0363320c760ce41ed2b8ffe575d9.webp',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260819/179c0363320c760ce41ed2b8ffe575d9.webp',
  payment: '',
  qq: '815568',
  tel: '13285071888',
  company_account_id: '6217 8580 0009 5314 560',
  company_bank: '段兴晨',
  company_bank_name: '中国银行',
  alipay_account_id: '815568@qq.com',
  alipay_name: '段兴晨',
  alipay_pic: '',
  wechat_pic: '',
  section_id: 5360361,
  belonger_id: 5360361,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 